import React from 'react';
import cn from 'classnames';
import './analytics-empty.scss';

export interface AnalyticsEmptyProps {
  img: string;
  text: string;
  title?: string;
  className?: string;
}

export const AnalyticsEmpty = ({ img, text, title, className }: AnalyticsEmptyProps) => (
  <div className={cn('analytics-empty', className)}>
    <img src={img} alt="empty" />
    {title && <span className="title">{title}</span>}
    <span>{text}</span>
  </div>
);
